<template>
    <div>
        <loading-custom :loading="loading" />

        <button
            type="button"
            class="btn btn-sm btn-dark"
            data-toggle="modal"
            data-target="#createPayment"
        >
            <i class="fa fa-plus"></i> เพิ่มช่องทางการชำระเงิน 
        </button>

        <div class="modal" id="createPayment" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="createPaymentLabel">
                            <h5 class="mb-0">เพิ่มช่องทางการชำระเงิน</h5>
                        </div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <label>ชื่อธนาคาร</label>
                            <vSelect
                                filterable
                                :options="banks"
                                label="label"
                                v-model="bankSelected"
                                @search="getBanks"
                                searchable
                            />
                        </div>
                        
                        <div v-if="bankSelected ? bankSelected.label == 'PayPal' : false">
                            <div class="form-group">
                                <label>PayPal Client ID</label>
                                <input
                                    v-model="form.client_id"
                                    type="text"
                                    class="form-control tw-placeholder-gray-300"
                                    placeholder="Paypal Client ID"
                                    required
                                />
                            </div>
                            <div class="form-group">
                                <label>PayPal Client Secret</label>
                                <input
                                    v-model="form.secret"
                                    type="text"
                                    class="form-control tw-placeholder-gray-300"
                                    placeholder="Paypal Client Secret"
                                    required
                                />
                            </div>
                            <div class="form-group">
                                <label>ชื่อบัญชี</label>
                                <input
                                    v-model="form.holder_name"
                                    type="text"
                                    class="form-control tw-placeholder-gray-300"
                                    placeholder="ชื่อบัญชี"
                                    required
                                />
                            </div>
                        </div>
                        <div v-else>
                            <div class="form-group">
                                <label>เลขบัญชี</label>
                                <input
                                    v-model="form.account_code"
                                    type="text"
                                    class="form-control tw-placeholder-gray-300"
                                    placeholder="เลขบัญชี"
                                    maxlength="18"
                                    required
                                />
                            </div>
                            <div class="form-group">
                                <label>ชื่อบัญชี</label>
                                <input
                                    v-model="form.holder_name"
                                    type="text"
                                    class="form-control tw-placeholder-gray-300"
                                    placeholder="ชื่อบัญชี"
                                    required
                                />
                            </div>
                            <div class="media">
                                <div class="media-left m-r-20" v-if="form.imageSrc">
                                    <img
                                        :src="form.imageSrc"
                                        class="user-photo media-object"
                                        alt="User"
                                    />
                                </div>
                                <div class="media-body">
                                    <label>เพิ่มรูป QR code ของบัญชีธนาคาร</label>
                                    <div
                                        class="tw-text-xs tw-text-gray-500 col-12 mb-2 p-0"
                                    >
                                        <span>Recommended : 600x600 pixels, </span>
                                    </div>
                                    <button
                                        type="button"
                                        class="btn btn-default"
                                        id="btn-upload-photo"
                                        @click="uploadImage"
                                    >
                                        อัพโหลด
                                    </button>
                                    <input
                                        type="file"
                                        id="filePhoto"
                                        @change="onFileChange"
                                        class="sr-only"
                                    />
                                </div>
                        </div>
                        </div>

                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-sm btn-default px-3"
                                data-dismiss="modal"
                            >
                                ยกเลิก
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-success px-3"
                                data-dismiss="modal"
                                @click="store"
                            >
                                บันทึก
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import vSelect from "vue-select";

export default {
    props: ["shop"],
    components: {
        vSelect
    },
    data() {
        return {
            banks: [],
            bankSelected: null,

            form: {
                bank_id: "",
                account_code: "",
                holder_name: "",
                image: null,
                imageSrc: "",
                client_id: "",
                secret: "",

            },
            loading: false
        };
    },
    created() {
        this.getBanks("");
    },
    methods: {
        getBanks(query) {
            axios
                .get(`/ajax/s/${this.shop}/banks`, { params: { text: query } })
                .then(response => {
                    this.banks = response.data.map(d => {
                        return {
                            value: d.id,
                            label: d.name
                        };
                    });
                })
                .catch(err => {
                    console.log("error get banks info");
                });
        },
        uploadImage() {
            document.getElementById("filePhoto").click();
        },
        async onFileChange(e) {
            let files = (await e.target.files) || e.dataTransfer.files;

            if (!files.length) {
                return;
            }

            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่เกินไป",
                    "กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                );
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้",
                    "กรุณาใช้รูปภาพสกุล jpg, jpeg หรือ png"
                );
            } else {
                this.form.image = files[0];
                this.previewImage(files[0]);
                document.getElementById("filePhoto").value = await "";
            }
        },
        previewImage(file) {
            this.form.imageSrc = URL.createObjectURL(file);
        },
        store() {
            this.loading = true;
            this.form.bank_id = this.bankSelected.value;
            let formData = new FormData();

            if (this.bankSelected.label == "PayPal") {
                formData.append("bank_id", this.form.bank_id);
                formData.append("holder_name", this.form.holder_name);
                formData.append("client_id", this.form.client_id);
                formData.append("secret", this.form.secret);
            } else {
                formData.append("bank_id", this.form.bank_id);
                formData.append("account_code", this.form.account_code);
                formData.append("holder_name", this.form.holder_name);

                if (this.form.image) {
                    formData.append("image", this.form.image);
                }
            }
                axios
                    .post(`/backend/s/${this.shop}/payments`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        this.loading = false;
                        window.location.reload();
                    })
                    .catch(err => {
                        this.$swal("error", "Sorry", "เกิดข้อผิดพลาด :" + err);
                        this.loading = false;
                    });
                }
            
        }
    }

</script>
<style lang="scss" scoped>
.media {
    @media (min-width: 0px) and (max-width: 992px) {
        width: 100%;
        flex-flow: column;
        flex-direction: column-reverse;
    }
}

.media-left {
    img {
        width: 100%;
        max-width: 200px;
    }
    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
    }
}
</style>
